// Import the lodash library and several utility functions related to scheduling.
import _ from "lodash";
import {
  generateScheduleItemLabel,
  generateStudentScheduleItemLabel,
} from "@/utils/scheduling/schedulingLabelGenerator";

import {
  roundOffTime,
} from "@/utils/scheduling/scheduleUtils";

import {
  updateStudentScheduleOccurrence
} from "@/services/schedulingService.js";
import moment from "moment";

// Function to render an appropriate label for an item based on its type.
function renderItemLabel(item, inMotion = false) {
  if (item.type === "schedule" || inMotion) {
    return generateScheduleItemLabel([{
      startTime: item.time.start,
      endTime: item.time.end,
    }]);
  } else if (item.type === "student-schedule") {
    return generateStudentScheduleItemLabel(item.details);
  }
}

// Helper function to round off time, render label, and update student schedules
async function processItem(item, roundOffTime, renderItemLabel) {
  item.time.start = roundOffTime(item.time.start);
  item.time.end = roundOffTime(item.time.end);
  item.label = renderItemLabel(item);

  const studentSchedules = item.details;
  for (const studentSchedule of studentSchedules) {
    const studentScheduleId = studentSchedule.id;
    const newTeacherId = studentSchedule.teacherId || studentSchedule.tempTeacherId;
    const newProgramId = studentSchedule.programId;
    const newClassroomId = studentSchedule.classroomId;
    const originalDate = moment(studentSchedule.startTime).format('YYYY-MM-DD');
    const newStartTime = item.time.start;
    const newEndTime = item.time.end;

    const newStudentSchedule = await updateStudentScheduleOccurrence(studentScheduleId, originalDate, newStartTime, newEndTime, newTeacherId, newClassroomId, newProgramId);

    studentSchedule.id = newStudentSchedule.id;
    studentSchedule.recurringDays = newStudentSchedule.recurring ? newStudentSchedule.recurringDays:null;
    studentSchedule.startTime = newStudentSchedule.startDate +'T'+ newStudentSchedule.startTime;
    studentSchedule.endTime = newStudentSchedule.endDate +'T'+ newStudentSchedule.endTime;
  }
  return item;
}

export const ResizeMove = {
  resizedItem(event) {
    const itemData = event.item.item;
    itemData.label = renderItemLabel(itemData, true);
    return this.debouncedResizedItem(itemData, roundOffTime, renderItemLabel);
  },
  debouncedResizedItem: _.debounce(function (item, roundOffTime, renderItemLabel) {
    return processItem(item, roundOffTime, renderItemLabel);
  }, 500),
  movedItem(event) {
    const itemData = event.item.item;
    itemData.label = renderItemLabel(itemData, true);
    return this.debouncedMovedItem(itemData, roundOffTime, renderItemLabel);
  },
  debouncedMovedItem: _.debounce(function (item, roundOffTime, renderItemLabel) {
    return processItem(item, roundOffTime, renderItemLabel);
  }, 800),
};
